import { render, staticRenderFns } from "./TradeLog.vue?vue&type=template&id=4a118ae7&scoped=true&"
import script from "./TradeLog.vue?vue&type=script&lang=js&"
export * from "./TradeLog.vue?vue&type=script&lang=js&"
import style0 from "./TradeLog.vue?vue&type=style&index=0&id=4a118ae7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a118ae7",
  null
  
)

export default component.exports